import React, { useEffect, useLayoutEffect, useState } from "react";
import Header from "../layout/Header";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Paginated from "./Paginated";
import { COLUMNS } from "./columnEvent";

const Event = () => {
  const [loader, setLoader] = useState(false);
  const [formData, setFormData] = useState([]);

  useLayoutEffect(() => {
    const tempData = [
      { code: 121, name: "test", event: "testing", isactive: false },
    ];
    if (tempData) {
      tempData?.map((val, ind) => {
        return (
          (val.code = val.code),
          (val.name = val.name),
          (val.event = val.event),
          (val.isactive = val.isactive === true ? "Active" : "Inactive"),
          (val.action = (
            <Link
              to="/event/add"
              state={val.code}
              className="edit_btn"
              csvalue="Edit"
            >
              <i className="fa-solid fa-pen"></i>
              <div className="show_div">Edit</div>
            </Link>
          ))
        );
      });
    }
    setFormData(tempData);
  }, []);

  return (
    <>
      <Header name={"Event Management"} />
      {loader && (
        <div className="mainPreloaderMain">
          <div className="mainPreloader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
      <div className="dashboard__content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <div className="dashboard__heading">
                <div className="dashboard__headingLeft">
                  <div className="dashboard__headingContent">
                    <Link to="/event/add">
                      <Button id="voucher" className="btn btn-primary btn-lg">
                        Create Event
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="dashboard__customersCard">
              <div className="dashboard__header">
                <div className="dashboard__left">
                  <h4 id="voucher_details">Event Details</h4>
                </div>
              </div>
              <div className="dashboard__body">
                {loader ? (
                  ""
                ) : (
                  <Paginated
                    data={formData ? formData : []}
                    columns={COLUMNS}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Event;
